import styled from 'styled-components';
import COLORS from '@pickles/shared/utils/colors';
import sizes from '../../util/sizes';

type StyleProps = {
  open?: boolean;
  bottom?: boolean;
  bgOnScroll?: boolean;
  navbarBgColor?: string;
  isInNavbar?: boolean;
};

export const RefundContainer = styled.div`
  font-size: 13px;
  color: ${COLORS.new_gray};
  width: 380px;
  > * {
    font-family: BasierCircle;
  }

  @media (max-width: ${sizes.M}) {
    width: 100%;
    padding: 0 20px;
  }
`;

type RefundTitleProps = {
  isMobile?: boolean;
};
export const RefundTitle = styled.div<RefundTitleProps>`
  font-weight: 600;
  font-size: 32px;
  text-align: ${({ isMobile }) => isMobile ? 'left' : 'center'};
  color: ${COLORS.rhino_black};
  margin-top: 10px;
  margin-bottom: 14px;
`;

type RefundDescriptionProps = {
  isMobile?: boolean;
};
export const RefundDescription = styled.div<RefundDescriptionProps>`
  display: flex;
  line-height: 150%;
  text-align: ${({ isMobile }) => isMobile ? 'justify' : 'center'};
  margin: 25px auto 30px auto;
  width: ${({ isMobile }) => isMobile ? '100%' : '300px'};
  white-space: pre-line;
  color: ${COLORS.san_juan_grey};
  font-size: 16px;
  > div {
    margin-bottom: 4px;
  }
`;

export const RefundOkButton = styled.button`
  background: ${COLORS.blumine_main_blue};
  border-radius: 8px;
  padding: 12px 28px 14px;
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.white};
  border: none;
  width: 173px;
  cursor: pointer;
  margin-bottom: 30px;
  display: block;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: ${sizes.M}) {
    position: absolute;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 40px);
  }
`;
